import React, { useEffect, useState } from 'react';
import {
  Grid,
  Box,
  FormControl,
  Select,
  MenuItem,
  TextField,
  Typography,
  // Divider,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import {
  StyledFilterPopup,
  DialogContentScrollbar,
  classes,
  Root,
  CancelButton,
  SaveButton,
  DialogActionsWithMargin,
  AndButton,
  // CustomDivider,
  AndTypography,
  OrButton,
  ColoredGrid,
  OrCloseIonButton,
  FilterPopUpHeader,
  FilterPopupCloseIcon,
  CustomDivider,
} from './utils';
import Toast from '../../utils/Toast';
import { INVALID_INPUT_REGEX } from '../../../../constants/staticContent';
import closeIcon from '../../../../assets/accountSetting-assets/x-circle.svg';

import MailListPopup from './MailListPopup';

const FilterPopUp = ({
  open,
  setFilterData,
  handleClose,
  isGmailSelectedForUpload,
  isOutlookSelectedForUpload,
  accessTokenForGmail,
  accessTokenForOutlook,
  automatedFlowSelected,
  documentType,
  uploadOption,
  selectedType,
  filterData,
  setIsDraggedChanged,
}) => {
  const [openMailDialog, setOpenMailDialog] = useState(false);
  const [queryData, setQueryData] = useState([]);
  const [gridData, setGridData] = useState([
    [
      {
        filter: '',
        filterName: '',
        condition: '',
        inputValue: '',
      },
    ],
  ]);
  const today = dayjs();
  let filters = ['From', 'To', 'Subject', 'Is', 'Before', 'After'];
  if (isGmailSelectedForUpload) {
    filters = [...filters, 'Label'];
  }

  const handlePopupClose = () => {
    setOpenMailDialog(false);
  };

  const handleGridChange = (gridIndex, conditionIndex, field, value) => {
    const updatedGridData = gridData.map((grid, gi) =>
      gi === gridIndex
        ? grid.map((condition, ci) =>
            ci === conditionIndex
              ? { ...condition, [field]: value }
              : condition,
          )
        : grid,
    );
    setGridData(updatedGridData);
  };

  const addCondition = (gridIndex) => {
    const gridIndexForAdd = gridData[gridIndex].length - 1;
    const { inputValue, filterName } = gridData[gridIndex][gridIndexForAdd];

    if (!inputValue) {
      Toast({ message: 'Please fill out this field', variant: 'warning' });
      return;
    }

    if (filterName === 'From' || filterName === 'To') {
      const isFirstLetterCapital =
        INVALID_INPUT_REGEX.EMAIL_CAPITAL.test(inputValue);
      const isValidEmail = INVALID_INPUT_REGEX.EMAIL.test(inputValue);
      if (!isValidEmail || !isFirstLetterCapital) {
        Toast({ message: 'Invalid email', variant: 'warning' });
        return;
      }
    }

    const updatedGridData = gridData.map((grid, gi) =>
      gi === gridIndex
        ? [
            ...grid,
            {
              filter: '',
              filterName: '',
              condition: '',
              inputValue: null,
            },
          ]
        : grid,
    );
    setGridData(updatedGridData);
  };

  const removeCondition = (gridIndex, conditionIndex) => {
    const updatedGridData = gridData
      .map((grid, gi) =>
        gi === gridIndex
          ? grid.filter((curr, ci) => ci !== conditionIndex)
          : grid,
      )
      .filter((curr) => curr.length);
    setGridData(updatedGridData);
  };

  const addGrid = () => {
    if (gridData.length > 0) {
      const GridLength = gridData.length - 1;
      const lastGridLength = gridData[GridLength].length - 1;
      const { inputValue, filterName } = gridData[GridLength][lastGridLength];
      if (!inputValue) {
        Toast({ message: 'Please fill out this field', variant: 'warning' });
      } else if (filterName === 'From' || filterName === 'To') {
        const isFirstLatterCapital =
          INVALID_INPUT_REGEX.EMAIL_CAPITAL.test(inputValue);
        const isValidEmail = INVALID_INPUT_REGEX.EMAIL.test(inputValue);
        if (!isValidEmail || !isFirstLatterCapital) {
          Toast({ message: 'Invalid email', variant: 'warning' });
          return;
        }
        setGridData([
          ...gridData,
          [
            {
              filter: '',
              filterName: '',
              condition: '',
              inputValue: '',
            },
          ],
        ]);
      } else {
        setGridData([
          ...gridData,
          [
            {
              filter: '',
              filterName: '',
              condition: '',
              inputValue: '',
            },
          ],
        ]);
      }
    } else {
      setGridData([
        ...gridData,
        [
          {
            filter: '',
            filterName: '',
            condition: '',
            inputValue: '',
          },
        ],
      ]);
    }
  };

  const handleSave = async () => {
    if (gridData.length === 0) {
      Toast({ message: 'No query selected', variant: 'warning' });
      return;
    }
    const GridLength = gridData.length - 1;
    const lastGridLength = gridData[GridLength].length - 1;
    const { inputValue, filterName } = gridData[GridLength][lastGridLength];
    if (!inputValue) {
      Toast({ message: 'Please fill out this field', variant: 'warning' });
      return;
    }

    if (filterName === 'From' || filterName === 'To') {
      const isFirstLetterCapital =
        INVALID_INPUT_REGEX.EMAIL_CAPITAL.test(inputValue);
      const isValidEmail = INVALID_INPUT_REGEX.EMAIL.test(inputValue);
      if (!isValidEmail || !isFirstLetterCapital) {
        Toast({ message: 'Invalid email', variant: 'warning' });
        return;
      }
    }

    if (automatedFlowSelected) {
      setFilterData((prev) => ({
        ...prev,
        [selectedType]: gridData,
      }));
      setIsDraggedChanged(true);
      handleClose();
    }

    setQueryData(gridData);
    setOpenMailDialog(true);
  };

  useEffect(() => {
    if (open && automatedFlowSelected) {
      setGridData(filterData[selectedType]);
    }
  }, [open, automatedFlowSelected]);

  return (
    <Root>
      <StyledFilterPopup open={open} onClose={handleClose} disableBackdropClick>
        <Box className={classes.header}>
          <FilterPopUpHeader id="customized-dialog-title">
            Add Filters
            <FilterPopupCloseIcon onClick={handleClose} src={closeIcon} />
          </FilterPopUpHeader>
        </Box>
        <DialogContentScrollbar>
          {gridData.map((grid, gridIndex) => (
            <Box key={`index${gridIndex + 1}`} width="100%">
              {grid.map((condition, conditionIndex) => (
                <ColoredGrid
                  container
                  columnSpacing={1}
                  key={`index${conditionIndex + 1}`}
                >
                  <Grid item xs={2.5}>
                    <FormControl fullWidth>
                      <Select
                        id="demo-simple-select"
                        value={condition.filter}
                        displayEmpty
                        onChange={(e) =>
                          handleGridChange(
                            gridIndex,
                            conditionIndex,
                            'filter',
                            e.target.value,
                          )
                        }
                      >
                        <MenuItem value="When">When</MenuItem>
                        <MenuItem value="ExceptWhen">Except When</MenuItem>
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={2.5}>
                    <FormControl
                      fullWidth
                      disabled={grid[conditionIndex].filter === ''}
                    >
                      <Select
                        id="demo-simple-select"
                        value={condition.filterName}
                        displayEmpty
                        onChange={(e) =>
                          handleGridChange(
                            gridIndex,
                            conditionIndex,
                            'filterName',
                            e.target.value,
                          )
                        }
                      >
                        {filters.map((curr) => (
                          <MenuItem key={curr} value={curr}>
                            {curr}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  {gridData[gridIndex][conditionIndex].filterName === 'From' ||
                  gridData[gridIndex][conditionIndex].filterName === 'To' ? (
                    <Grid item xs={5}>
                      <TextField
                        id="outlined-basic"
                        fullWidth
                        variant="outlined"
                        className={classes.textField}
                        value={condition.inputValue}
                        onChange={(e) =>
                          handleGridChange(
                            gridIndex,
                            conditionIndex,
                            'inputValue',
                            e.target.value,
                          )
                        }
                        disabled={grid[conditionIndex].filterName === ''}
                      />
                    </Grid>
                  ) : null}
                  {gridData[gridIndex][conditionIndex].filterName ===
                    'Subject' ||
                  gridData[gridIndex][conditionIndex].filterName === 'Label' ? (
                    <Grid item xs={5}>
                      <TextField
                        id="outlined-basic"
                        fullWidth
                        variant="outlined"
                        className={classes.textField}
                        value={condition.inputValue}
                        onChange={(e) =>
                          handleGridChange(
                            gridIndex,
                            conditionIndex,
                            'inputValue',
                            e.target.value,
                          )
                        }
                        disabled={grid[conditionIndex].filterName === ''}
                      />
                    </Grid>
                  ) : null}
                  {gridData[gridIndex][conditionIndex].filterName === 'Is' ? (
                    <Grid item xs={5}>
                      <FormControl fullWidth>
                        <Select
                          id="demo-simple-select"
                          value={condition.inputValue}
                          displayEmpty
                          onChange={(e) =>
                            handleGridChange(
                              gridIndex,
                              conditionIndex,
                              'inputValue',
                              e.target.value,
                            )
                          }
                        >
                          {!isOutlookSelectedForUpload && (
                            <MenuItem value="Starred">Starred</MenuItem>
                          )}
                          <MenuItem value="Read">Read</MenuItem>
                          <MenuItem value="Unread">Unread</MenuItem>
                        </Select>
                      </FormControl>
                    </Grid>
                  ) : null}
                  {gridData[gridIndex][conditionIndex].filterName ===
                    'Before' ||
                  gridData[gridIndex][conditionIndex].filterName === 'After' ? (
                    <Grid item xs={5}>
                      <FormControl fullWidth>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DatePicker
                            value={condition.inputValue || null}
                            maxDate={today}
                            onChange={(newValue) =>
                              handleGridChange(
                                gridIndex,
                                conditionIndex,
                                'inputValue',
                                newValue,
                              )
                            }
                            renderInput={(params) => <TextField {...params} />}
                          />
                        </LocalizationProvider>
                      </FormControl>
                    </Grid>
                  ) : null}
                  {!gridData[gridIndex][conditionIndex].filterName ? (
                    <Grid item xs={5} />
                  ) : null}
                  <Grid
                    item
                    xs={2}
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                    gap="15px"
                  >
                    <OrButton onClick={() => addCondition(gridIndex)}>
                      OR
                    </OrButton>
                    <OrCloseIonButton
                      aria-label="close"
                      onClick={() => removeCondition(gridIndex, conditionIndex)}
                    >
                      <CloseIcon />
                    </OrCloseIonButton>
                  </Grid>
                </ColoredGrid>
              ))}

              {gridData[gridIndex]?.length > 0 &&
              gridData[gridIndex + 1]?.length > 0 ? (
                <Box>
                  <CustomDivider
                    orientation="horizontal"
                    variant="middle"
                    flexItem
                  >
                    <AndTypography variant="subtitle2">AND</AndTypography>
                  </CustomDivider>
                </Box>
              ) : (
                ''
              )}
            </Box>
          ))}
          <AndButton onClick={addGrid}>AND</AndButton>
        </DialogContentScrollbar>
        <DialogActionsWithMargin>
          <Box className={classes.actionButtonBox}>
            <CancelButton
              className={classes.cancelButton}
              onClick={handleClose}
            >
              <Typography variant="body1">Cancel</Typography>
            </CancelButton>
            <SaveButton
              variant="contained"
              onClick={handleSave}
              className={classes.saveButton}
            >
              <Typography variant="body1">Save</Typography>
            </SaveButton>
          </Box>
        </DialogActionsWithMargin>
        {openMailDialog && !automatedFlowSelected ? (
          <MailListPopup
            open={openMailDialog}
            handlePopupClose={handlePopupClose}
            handleClose={handleClose}
            queryData={queryData}
            accessTokenForGmail={accessTokenForGmail}
            accessTokenForOutlook={accessTokenForOutlook}
            isGmailSelectedForUpload={isGmailSelectedForUpload}
            isOutlookSelectedForUpload={isOutlookSelectedForUpload}
            documentType={documentType}
            uploadOption={uploadOption}
          />
        ) : null}
      </StyledFilterPopup>
    </Root>
  );
};

FilterPopUp.defaultProps = {
  setFilterData: null,
  automatedFlowSelected: false,
  selectedType: null,
  filterData: null,
};

FilterPopUp.propTypes = {
  open: PropTypes.bool.isRequired,
  automatedFlowSelected: PropTypes.bool,
  setFilterData: PropTypes.func,
  accessTokenForGmail: PropTypes.string.isRequired,
  accessTokenForOutlook: PropTypes.string.isRequired,
  isGmailSelectedForUpload: PropTypes.bool.isRequired,
  isOutlookSelectedForUpload: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  documentType: PropTypes.string.isRequired,
  uploadOption: PropTypes.string.isRequired,
  selectedType: PropTypes.string,
  filterData: PropTypes.string,
  setIsDraggedChanged: PropTypes.bool.isRequired,
};

export default FilterPopUp;
